import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import { useAppDispatch, useAppSelector, useBrowserBackClickHandler } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { Helmet } from '../../../../components/Helmet';
import { OldPassword } from '../../components/ChangePassword/OldPassword';
import { SetNewPassword } from '../../components/ChangePassword/SetNewPassword';
import { ChangePasswordStep } from '../../enums';
import { settingsActions } from '../../redux/slice/settingsSlice';

export const PasswordChangePage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { step } = useAppSelector((state) => state.recruiterAppSettings.changePassword);
    const { referrer } = useAppSelector((state) => state.app);

    const [savedReferrerLocation, setSavedReferrerLocation] = useState('');

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        return function () {
            dispatch(settingsActions.clearData());
        };
    }, []);

    useEffect(() => {
        if (location.state?.from?.pathname) {
            setSavedReferrerLocation(location.state.from.pathname);
        }
    }, [location]);

    const onBackClick = useCallback(() => {
        if (step === ChangePasswordStep.OldPassword) {
            if (savedReferrerLocation) {
                navigate(savedReferrerLocation);
                return;
            }
            if (referrer) {
                window.location.href = referrer;
                return;
            }
        }

        dispatch(settingsActions.setChangePasswordStep(step - 1));
    }, [step, referrer, savedReferrerLocation]);

    useBrowserBackClickHandler(onBackClick);

    const content = useMemo(() => {
        switch (step) {
            case ChangePasswordStep.OldPassword:
                return <OldPassword />;
            case ChangePasswordStep.NewPassword:
                return <SetNewPassword />;
        }
    }, [step]);

    return (
        <>
            <Helmet pageName={__t('Смена пароля')} />
            <div className='password-change-page'>
                <Header title={__t('Смена пароля')} onBackClick={onBackClick} />
                {content}
            </div>
        </>
    );
};
